
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Globe, Smartphone } from "lucide-react";

export const NetworkRulesLoadingTable = () => {
  return (
    <Tabs value="system-wide" className="space-y-6">
      <div className="border-b border-gray-200">
        <TabsList className="grid w-full grid-cols-2 bg-transparent h-auto p-0 rounded-none max-w-2xl">
          <TabsTrigger 
            value="system-wide"
            className="data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-blue-500 data-[state=active]:text-blue-600 rounded-none py-3 px-4 text-sm font-medium"
          >
            <Globe className="w-4 h-4 mr-2" />
            System-wide (-)
          </TabsTrigger>
          <TabsTrigger 
            value="app-specific"
            className="rounded-none py-3 px-4 text-sm font-medium"
          >
            <Smartphone className="w-4 h-4 mr-2" />
            App Specific (-)
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="system-wide" className="space-y-6">
        <div className="text-sm text-gray-500 bg-blue-50 border border-blue-200 rounded-lg p-3">
          These rules apply across all apps. Bundle IDs can be specified to target specific components.
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[250px]">Rule Name</TableHead>
                <TableHead className="w-[120px]">Type</TableHead>
                <TableHead className="w-[120px]">URLs</TableHead>
                <TableHead className="w-[120px]">Scope</TableHead>
                <TableHead className="w-[120px]">Modified</TableHead>
                <TableHead className="w-[50px]"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {/* Loading skeleton rows */}
              {Array.from({ length: 5 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <div className="flex items-center">
                      <Skeleton className="w-8 h-8 rounded-lg mr-3" />
                      <div className="space-y-1">
                        <Skeleton className="h-4 w-32" />
                        <Skeleton className="h-3 w-20" />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-6 w-20 rounded-full" />
                  </TableCell>
                  <TableCell>
                    <div className="space-y-1">
                      <Skeleton className="h-4 w-16" />
                      <Skeleton className="h-3 w-12" />
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="space-y-1">
                      <Skeleton className="h-4 w-20" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-16" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="w-5 h-5" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          
          <div className="flex items-center justify-center py-8">
            <div className="text-gray-500">Loading network rules...</div>
          </div>
        </div>
      </TabsContent>
    </Tabs>
  );
};
